import { Stack } from 'components/Stack';
import styled from 'styled-components';
import { mediaBreakpointUp } from 'styles/grid';

export const Heading = styled.span`
  font-size: 16px;
  font-weight: 700;
  line-height: 21px;
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
`;

export const Instruction = styled.span`
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
`;

export const UploadContainer = styled(Stack).attrs({
  direction: 'column',
  gap: 16,
})`
  width: 100%;
  ${mediaBreakpointUp.md} {
    width: 455px;
  }
`;

export const InstructionContainer = styled(Stack).attrs({
  direction: 'column',
  gap: 8,
})`
  flex: 1;
`;
